import * as React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'primereact/button'
import PubRouter from './routes/routes.js'

const PubMain: React.FC = () => {
    const gnb = [
        { name: '메인' },
        { name: '공통' },
        { name: '상품몰' },
        { name: '금융서비스' },
        { name: 'IBK모임 서비스' },
        { name: '비대면서류접수' },
        { name: '기타' },
    ]

    const [iurl, setIurl] = React.useState('/pub/com/SC-COM-1000-F')
    const [iview, setIview] = React.useState('')

    const IframeHandle = (url) => {
        setIurl(`/pub/${url}`)
        url && setIview('on')
    }
    const IframeClose = () => setIview('')

    const titleTarget = (id) => {
        planFilterHandle('')
        stateFilterHandle('')
        setTimeout(() => {
            document
                .getElementById(`title${id}`)
                .scrollIntoView({ behavior: 'smooth' })
        })
    }

    React.useEffect(() => {
        document.documentElement.style.scrollPaddingTop = '55px'
    }, [])

    const stateEnd = PubRouter.filter((item) => item.state === '완료').length
    const stateDel = PubRouter.filter((item) => item.state === '삭제').length

    const [openNoteIndex, setOpenNoteIndex] = React.useState({}) // 비고 더보기

    // 계획일 필터
    const [planFilter, setPlanFilter] = React.useState(false)
    const [planFilterSelected, setPlanFilterSelected] = React.useState('')
    const planFilterHandle = (value) => {
        setPlanFilterSelected(value)
        setPlanFilter(false)
    }

    // 상태 필터
    const [stateFilter, setStateFilter] = React.useState(false)
    const [stateFilterSelected, setStateFilterSelected] = React.useState('')
    const stateFilterHandle = (value) => {
        setStateFilterSelected(value)
        setStateFilter(false)
    }

    const filteredList = PubRouter.filter((item) => {
        if (planFilterSelected && stateFilterSelected) {
            return (
                item.plan === planFilterSelected &&
                item.state === stateFilterSelected
            )
        }
        if (planFilterSelected) {
            return item.plan === planFilterSelected
        }
        if (stateFilterSelected) {
            return item.state === stateFilterSelected
        }
        return true
    })

    return (
        <div className="worklist-container">
            <header className="gnb">
                <h1>
                    <Link to="/pub">
                        <span className="blind">IBK기업은행</span>
                    </Link>
                </h1>
                <nav>
                    {gnb.map((menu, index) => (
                        <Button
                            key={`menu${index}`}
                            className="btn"
                            onClick={() => titleTarget(index)}
                        >
                            {menu.name}
                        </Button>
                    ))}
                    <Link
                        to="/pub/PubComp"
                        target="_blank"
                        className="btn point"
                    >
                        컴포넌트
                    </Link>
                </nav>
                <div className="safe-info">
                    <div className="info-item">
                        <div className="key">진행</div>
                        <div className="value ing">
                            {
                                PubRouter.filter(
                                    (item) => item.state === '진행'
                                ).length
                            }
                        </div>
                    </div>
                    <div className="info-item">
                        <div className="key">컨펌</div>
                        <div className="value confirm">
                            {
                                PubRouter.filter(
                                    (item) => item.state === '컨펌'
                                ).length
                            }
                        </div>
                    </div>
                    <div className="info-item">
                        <div className="key">최종완료</div>
                        <div className="value end">
                            {
                                PubRouter.filter(
                                    (item) => item.state === '완료'
                                ).length
                            }
                        </div>
                    </div>
                    <div className="info-item">
                        <div className="key">수정</div>
                        <div className="value modify">
                            {
                                PubRouter.filter(
                                    (item) => item.state === '수정'
                                ).length
                            }
                        </div>
                    </div>
                    <div className="info-item">
                        <div className="key">삭제</div>
                        <div className="value del">
                            {
                                PubRouter.filter(
                                    (item) => item.state === '삭제'
                                ).length
                            }
                        </div>
                    </div>
                    <div className="info-progress">
                        <div className="progress">
                            <div className="total">
                                <div className="text">
                                    전체
                                    <strong className="count">
                                        {
                                            PubRouter.filter((item) => item.id)
                                                .length
                                        }
                                    </strong>
                                    개
                                </div>
                            </div>
                            <div
                                className="done"
                                data-persent={Math.round(
                                    ((stateEnd + stateDel) /
                                        PubRouter.filter((item) => item.id)
                                            .length) *
                                        100
                                )}
                                style={{
                                    width: `${
                                        ((stateEnd + stateDel) /
                                            PubRouter.filter((item) => item.id)
                                                .length) *
                                        100
                                    }%`,
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
            </header>
            <ul className="desc">
                <li data-state="진행">작업 진행중</li>
                <li data-state="컨펌">기획,디자인 확인요청</li>
                <li data-state="완료">기획,디자인 확인완료 배포</li>
                <li data-state="수정">완료 후 수정 (다음 배포때 완료처리)</li>
                <li data-state="삭제">완료 후 삭제</li>
            </ul>
            <div className="data-table">
                <header>
                    <strong data-label="depth2">DEPTH2</strong>
                    <strong data-label="depth3">DEPTH3</strong>
                    <strong data-label="depth4">DEPTH4</strong>
                    <strong data-label="depth5">DEPTH5</strong>
                    <strong data-label="화면명">화면명</strong>
                    <strong data-label="구분">구분</strong>
                    <strong data-label="URL">URL</strong>
                    <strong data-label="계획일">
                        <Button
                            className="bold"
                            onClick={() => {
                                setPlanFilter((prev) => !prev)
                            }}
                        >
                            계획일 <i className="pi pi-sort-down-fill"></i>
                        </Button>
                        <span
                            className={`filter-list ${
                                planFilter ? 'open' : ''
                            }`.trim()}
                        >
                            <Button
                                label="전체"
                                onClick={() => planFilterHandle('')}
                            />
                            {[...PubRouter]
                                .filter((item) => item?.plan)
                                .sort((a, b) =>
                                    String(a.plan).localeCompare(String(b.plan))
                                )
                                .filter(
                                    (item, index, self) =>
                                        self.findIndex(
                                            (v) => v.plan === item.plan
                                        ) === index
                                )
                                .map((item, index) => (
                                    <Button
                                        key={`plan${index}`}
                                        label={item.plan}
                                        onClick={() =>
                                            planFilterHandle(item.plan)
                                        }
                                    />
                                ))}
                        </span>
                    </strong>
                    <strong data-label="완료일">완료일</strong>
                    <strong data-label="상태">
                        <Button
                            className="bold"
                            onClick={() => {
                                setStateFilter((prev) => !prev)
                            }}
                        >
                            상태 <i className="pi pi-sort-down-fill"></i>
                        </Button>
                        <span
                            className={`filter-list ${
                                stateFilter ? 'open' : ''
                            }`.trim()}
                        >
                            <Button
                                label="전체"
                                onClick={() => stateFilterHandle('')}
                            />
                            {[...PubRouter]
                                .filter((item) => item?.state)
                                .sort((a, b) =>
                                    String(b.state).localeCompare(
                                        String(a.state)
                                    )
                                )
                                .filter(
                                    (item, index, self) =>
                                        self.findIndex(
                                            (v) => v.state === item.state
                                        ) === index
                                )
                                .map((item, index) => (
                                    <Button
                                        key={`plan${index}`}
                                        label={item.state}
                                        onClick={() =>
                                            stateFilterHandle(item.state)
                                        }
                                    />
                                ))}
                        </span>
                    </strong>
                    <strong data-label="작업자">작업자</strong>
                    <strong data-label="비고">비고</strong>
                </header>
                <table>
                    <tbody>
                        {filteredList.map((item, index) =>
                            item.title ? (
                                <tr key={`list${index}`}>
                                    <th
                                        colSpan={12}
                                        id={`title${item.titleId}`}
                                        className="title"
                                    >
                                        {item.title}
                                    </th>
                                </tr>
                            ) : (
                                <tr
                                    key={`list${index}`}
                                    className={`${
                                        item.state === '삭제' ? 'del' : ''
                                    } `.trim()}
                                >
                                    <td
                                        data-label="depth2"
                                        data-label-text={item.depth2}
                                    >
                                        {item.depth2}
                                    </td>
                                    <td
                                        data-label="depth3"
                                        data-label-text={item.depth3}
                                    >
                                        {item.depth3}
                                    </td>
                                    <td
                                        data-label="depth4"
                                        data-label-text={item.depth4}
                                    >
                                        {item.depth4}
                                    </td>
                                    <td
                                        data-label="depth5"
                                        data-label-text={item.depth5}
                                    >
                                        {item.depth5}
                                    </td>
                                    <td data-label="화면명">{item.name}</td>
                                    <td data-label="구분">{item.type}</td>
                                    <td data-label="URL">
                                        {item.uxw === true ? (
                                            <i
                                                className="pi pi-verified"
                                                title="UXWriting 완료"
                                            ></i>
                                        ) : (
                                            ''
                                        )}
                                        <Button
                                            onClick={() =>
                                                IframeHandle(
                                                    `${item.dir}/${item.id}`
                                                )
                                            }
                                        >
                                            {item.id}
                                        </Button>
                                        <Link
                                            to={`${item.dir}/${item.id}`}
                                            target="_blank"
                                            title="새창열기"
                                        >
                                            <i className="pi pi-window-maximize"></i>
                                            <span className="view">
                                                {item.id}
                                            </span>
                                        </Link>
                                        {item.devUrl && (
                                            <a
                                                href={`http://mbrdev.ibk.co.kr/${item.devUrl}`}
                                                target="_blank"
                                                title="개발화면"
                                            >
                                                <i className="pi pi-wrench"></i>
                                            </a>
                                        )}
                                    </td>
                                    <td data-label="계획일">{item.plan}</td>
                                    <td data-label="완료일">{item.end}</td>
                                    <td
                                        data-label="상태"
                                        data-state={item.state}
                                    >
                                        <span>{item.state}</span>
                                    </td>
                                    <td data-label="작업자">{item.user}</td>
                                    <td data-label="비고">
                                        {item.etc && (
                                            <>
                                                <ul
                                                    className={
                                                        openNoteIndex[index]
                                                            ? 'open'
                                                            : ''
                                                    }
                                                >
                                                    {item.etc
                                                        .split(',')
                                                        .map((text, index) => (
                                                            <li
                                                                key={`etc${index}`}
                                                            >
                                                                <Button
                                                                    title={`V${
                                                                        index +
                                                                        1
                                                                    }`}
                                                                    onClick={() =>
                                                                        IframeHandle(
                                                                            `${
                                                                                item.dir
                                                                            }/${
                                                                                item.id
                                                                            }-V${
                                                                                index +
                                                                                1
                                                                            }`
                                                                        )
                                                                    }
                                                                >
                                                                    -{' '}
                                                                    {text.trim()}
                                                                </Button>
                                                            </li>
                                                        ))}
                                                </ul>
                                                {item.etc.split(',').length >
                                                    2 && (
                                                    <Button
                                                        className="btn-more"
                                                        onClick={() => {
                                                            setOpenNoteIndex(
                                                                (prev) => ({
                                                                    ...prev,
                                                                    [index]:
                                                                        !prev[
                                                                            index
                                                                        ],
                                                                })
                                                            )
                                                        }}
                                                    >
                                                        <i className="pi pi-angle-down"></i>
                                                    </Button>
                                                )}
                                            </>
                                        )}
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>

            <aside className={iview}>
                <Button
                    className="btn-close"
                    onClick={IframeClose}
                    aria-label="미리보기 창닫기"
                >
                    <i
                        className="pi pi-times"
                        style={{ fontSize: '2.5rem' }}
                    ></i>
                </Button>
                <iframe src={iurl} name="view"></iframe>
            </aside>
        </div>
    )
}

export default PubMain
